{
  "checkBackSoonMessage": "Esperamos que esta función esté disponible en breve. ¡Vuelva pronto!",
  "contactUs": "Contáctenos",
  "errorBoundaryTitle": "Algo salió mal",
  "featureInProgressMobileWithWebappUrl": "Estamos trabajando para trasladar esta función desde nuestra aplicación web a las plataformas móviles. Mientras tanto, puedes usar esta función en {{webappUrl}}",
  "loadErrorDismissButton": "Despedir",
  "retryButton": "Rever",
  "loadErrorMessage": "Nuestro equipo ha sido notificado y está trabajando para resolver el problema.",
  "loadErrorSupportTicketLink": "Crear un ticket de soporte",
  "loadErrorSupportTicketMessage": "Cree un ticket de soporte para rastrear su problema.",
  "loadErrorTitle": "Algo salió mal",
  "notFoundMessage": "El contenido solicitado no existe.",
  "notFoundTitle": "Extraviado",
  "permissionDeniedHowToGetPermissionHint": "Para obtener acceso a esta función, comuníquese con un administrador de su cuenta de granja.",
  "permissionDeniedMessage": "No tienes permiso para realizar esta acción.",
  "permissionDeniedMissingPermissions": "Permisos faltantes:",
  "permissionDeniedTitle": "Permiso denegado",
  "reloadButton": "Recargar",
  "underConstruction": "En construcción"
}
